// ChildMenu.js
import React, { Component } from 'react';
import { List, Typography, Divider } from 'antd';
import './help.scss';

const { Title, Paragraph } = Typography;

class ChildMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getMenuContent(menu) {
	switch (menu) {
		case 'Overview':
			return [
			  {
				title: "Domain Overview",
				description: "Manage your domain endpoints and traffic patterns:",
				items: [
				  "View active endpoints status",
				  "Monitor total routing rules",
				  "Check traffic patterns",
				  "Quick access to domain management"
				]
			  },
			  {
				title: "Dashboard Features",
				description: "Key features available on the overview page:",
				items: [
				  "Real-time endpoint health status",
				  "Traffic routing rules overview",
				  "Traffic pattern visualization",
				  "Quick actions for configuration"
				]
			  }
			];
		  
		case 'Domains':
		return [
			{
			title: "Domain Management",
			description: "Manage your domains and configurations:",
			items: [
				"Add new domains to the system",
				"Configure domain settings",
				"Monitor domain status",
				"View domain creation dates"
			]
			},
			{
			title: "Domain Operations",
			description: "Available actions for domains:",
			items: [
				"Configure routing rules",
				"Enable/disable domains",
				"Delete domain configurations",
				"Refresh domain status"
			]
			}
		];
		
		case 'Endpoints':
		return [
			{
			title: "Endpoints & Health",
			description: "Monitor and manage your endpoints:",
			items: [
				"View endpoint health status",
				"Add new endpoints",
				"Configure health check URLs",
				"Monitor endpoint creation and update times"
			]
			},
			{
			title: "Health Management",
			description: "Health monitoring features:",
			items: [
				"Real-time health status monitoring",
				"Endpoint health checks",
				"Health status history",
				"Quick endpoint configuration"
			]
			}
		];
		
		case 'Traffic':
		return [
			{
			title: "Traffic Analysis",
			description: "Monitor and analyze traffic patterns:",
			items: [
				"View total requests and daily averages",
				"Analyze traffic flow visualization",
				"Check traffic distribution by rules",
				"Monitor traffic patterns over time"
			]
			},
			{
			title: "Traffic Details",
			description: "Detailed traffic information:",
			items: [
				"View traffic by country and ISP",
				"Check routing rule effectiveness",
				"Monitor endpoint distribution",
				"Analyze traffic timestamps"
			]
			}
	    ];
  
	  default:
		return [
		  {
			title: "Documentation",
			description: "Please select a topic from the menu to view its documentation.",
			items: []
		  }
		];
	}
  }

  render() {
    const { menu } = this.props;
    const content = this.getMenuContent(menu);

    return (
      <div className="help-content">
        <List
          itemLayout="vertical"
          dataSource={content}
          renderItem={item => (
            <List.Item>
              <Title level={4}>{item.title}</Title>
              <Paragraph>{item.description}</Paragraph>
              <List
                dataSource={item.items}
                renderItem={subItem => (
                  <List.Item>
                    • {subItem}
                  </List.Item>
                )}
              />
              <Divider />
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default ChildMenu;
